import { useCallback, useRef } from 'react';
import type { DependencyList } from 'react';

export function useSingletonCallback<T extends unknown[]>(
  callback: (...args: T) => void,
  deps: DependencyList
): (...args: T) => void {
  const inProgressRef = useRef(false);

  return useCallback(async (...args: T) => {
    if (inProgressRef.current) {
      return;
    }
    inProgressRef.current = true;
    try {
      return callback(...args);
    } finally {
      inProgressRef.current = false;
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
